<ion-content class="top-container content theme1" fullscreen="true">

    <div class="content-wrapper">
        <div class="language-btn-box">
            <custom-back-button [forceHideText]="true" *ngIf="sdkConfigService.isAvailable()"
                                (backButtonClick)="backButtonClick()"></custom-back-button>
            <ion-button (click)="presentPopover($event)" color="light" fill="solid" size="small" class="disable-hover"
                        *ngIf="langs && langs.length > 1">
                <ion-icon class="icon-lang" slot="start" name='globe' is-active="false"></ion-icon>
                Language / 語言
            </ion-button>
        </div>

        <div *ngIf="brand" class="top-container themeText" (click)="startClicked()">
            <div class="info-container">
                <div class="k-logo-box">
                    <img class="k-logo-img" src="{{brand.getImage('logo', 360, false)}}">
                </div>
            </div>
            <!-- Store name -->
            <div class="shop-info-box">
                <p class="shop-info-text break-line txtShadowOnBlack">{{brand.name}}</p>
            </div>

        </div>
    </div>

</ion-content>

<ion-footer class="aigens-footer abs-footer">

    <!-- start indicator -->
    <div class="start-btn-wrapper">
        <ion-button size="large" color="primary" class="start-btn" (click)="startClicked();$event.stopPropagation()"
                    [ngStyle]="{'font-size': orderService.screenWidthUnit * 6 + 'px'}">
            {{"pages.splash.start" | translate}}
            <ion-icon slot="end" name="arrow-round-forward"></ion-icon>
        </ion-button>
    </div>

    <!-- bottom buttons -->
    <div class="bottom-btn-box" *ngIf="!(settings?.hideHistory)">
        <ion-button *ngIf="login" (click)="goToLogin();$event.stopPropagation()" color="light"
                    class="disable-hover AQA-login">
            <ion-icon slot="start" name="person"></ion-icon>
            <ng-container *ngIf="!memberService.getMember()"> {{"pages.splash.login" | translate}}</ng-container>
            <ng-container *ngIf="memberService.getMember()"> {{"pages.splash.member" | translate}}</ng-container>
        </ion-button>
        <ion-button *ngIf="!orderService.preOrder" (click)="openOrderSummary();$event.stopPropagation()" color="light"
                    class="disable-hover summary-button">
            <ion-icon slot="start" name='paper' is-active="false">
                <ion-badge *ngIf="false" color="contrast">0</ion-badge>
            </ion-icon>
            {{"pages.splash.summary" | translate}}
        </ion-button>
    </div>

    <!-- aigens logo -->
    <div class="themeText">
        <ng-container *ngIf="settings?.smallLogo">
            <div class="themeText">
                <p class="aigens-tag">{{"global.powered-by" | translate}}
                    <ng-container *ngIf="license">{{license}}</ng-container>
                </p>
            </div>
        </ng-container>
        <ng-container *ngIf="!(settings?.smallLogo)">
            <img src="assets/images/aigens-footer.svg" class="logo-aigens">
        </ng-container>
    </div>
    <div class="version-text">
        <span>v{{v}}</span>
    </div>
</ion-footer>
